// Generated — do not edit.
//
// Built from design/brand.json by scripts/build-brand.mjs. Edit the source and
// re-run `npm run build:brand`; `npm run check:brand` fails if this file has
// drifted from it, or if the name below is typed anywhere a screen could have
// read it from here.
//
// In src/domain/ so that the mirror the Cloud Functions load carries it too:
// the From name a studio previews in the browser (sendingIdentity.js) and the
// one functions/delivery/ puts on the envelope are then the same words by
// construction rather than by two people remembering.

export const BRAND = Object.freeze({
  name: 'Lesson Lineup',
  domain: 'lessonlineup.app',
  bundleId: 'app.lessonlineup',
});
